<template>
  <header
    class="site-header"
    :class="{ 'open' : isOpen }"
  >

    <span
      v-if="isOpen"
      @click="toggleMenu()"
      class="background"
    ></span>

    <div class="content-max-width">

      <a
        href="/"
        class="logo"
        @click="$store.commit('setNotice', true)"
      >
        <img src="/images/logo.png" alt="Website Logo" />
      </a>

      <div class="call">
        <a :href="data.aus_link_url" class="aus desktop" target="_blank">AUSTRALIA</a>
        <a :href="data.nz_link_url" class="nz desktop" target="_blank">NEW ZEALAND</a>
        <a v-if="data.phone_url && data.phone" :href="`tel:${data.phone_url}`" class="ph" target="_blank"><span class="free">FREE CALL </span>{{data.phone}}</a>
      </div>

      <nav>
        <ul>
          <li
            v-for="(link, index) of menu"
            :key="index"
            :class="{ desktop: !(level1Active === null || level1Active === index), active: level1Active === index }"
          >
            <span v-show="mobileActiveLevel == 0" class="flex justify-between w-100">
              <a :href="link.url">{{ link.title }}</a>
              <span v-if="link.children" class="ml-auto text-white mobile material-icons" @click="setMobileState(index)">chevron_right</span>
            </span>

            <ul
              v-if="link.children"
              class="child"
              :class="{
                desktop: level1Active !== index,
                open: level1Active === index && level2Active === null,
                active: level1Active === index && level2Active !== null,
              }"
            >
              <li
                class="flex items-center text-white back mobile"
                :class="{ desktop: level2Active !== null }"
                @click="setMobileState()"
              >
                <span class="text-[#FDDD00] mobile material-icons">chevron_left</span>
                 <span class="uppercase">{{ link.title }}</span>
              </li>
              <li
                v-for="(child, childIndex) of link.children"
                :key="childIndex"
                :class="{ third: child.children, active: level1Active === index && level2Active === childIndex }"
              >
                <span class="flex justify-between w-100" :class="{ desktop: level1Active !== index || level2Active !== null }">
                  <a :href="child.url">
                    {{ child.title }}
                  </a>
                  <span v-if="child.children" class="text-white mobile material-icons" @click="setMobileState(index, childIndex)">chevron_right</span>
                </span>

                <ul
                  v-if="child.children"
                  class="third-tier"
                  :class="{ desktop: level2Active !== childIndex, open: level1Active === index && level2Active === childIndex }"
                >
                  <li class="text-white mobile uppsercase" @click="setMobileState(index)">
                    <span class="text-[#FDDD00] material-icons">chevron_left</span>
                    {{ child.title }}
                  </li>
                  <li
                    v-for="(grandChild, grandChildIndex) of child.children"
                    :key="grandChildIndex"
                  >
                    <a :href="grandChild.url">{{ grandChild.title }}</a>
                  </li>
                </ul>
              </li>
            </ul>

          </li>
        </ul>
      </nav>

      <button class="hamburger mobile" @click="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>
  </header>
</template>

<script>
export default {
  props: {
    menu: Array,
    data: Object
  },

  data: () => ({
    isOpen: false,
    nav: [],
    level1Active: null,
    level2Active: null,
  }),

  computed: {
    mobileActiveLevel () {
      if (this.level2Active !== null) {
        return 2
      }

      if (this.level1Active !== null) {
        return 1
      }

      return 0
    },
  },

  mounted () {
    this.nav = this.menu
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
      this.$parent.navToggle(this.isOpen)

      // reset mobile state if mobile menu is dismissed
      if (!this.isOpen) {
        this.setMobileState()
      }
    },

    setMobileState (level1Active = null, level2Active = null) {
      this.level1Active = level1Active
      this.level2Active = level2Active
    },
  }
};
</script>
